import request from '@/utils/request'

/**
 * 用户登录模块请求接口（包括注册）
 */
const userApi = {
  Login: '/patient-BaaS-proxy/login',
  Logout: '/patient-BaaS-proxy/logout',
  userInfo: '/patient-BaaS-proxy/clinic/getPatientInfo',
  Register: '/patient-BaaS-proxy/register'
}

/**
 * 登录
 * @param {*} data 
 * @returns 
 */
export function login (data) {
  return request({
    url: userApi.Login+'?username='+data.username+'&password='+data.password,
    method: 'post',
    data
  })
}
/**
 * 退出登录
 * @returns 
 */
export function logout (data) {
  return request({
    url: userApi.Logout,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data
  })
}

/**
 * 获取用户信息
 * @returns 
 */
export function getUserInfo(data){
  return request({
    url: userApi.userInfo,
    method: 'post',
    data
  })
}

/**
 * 注册
 * @param {*} data 
 * @returns 
 */
export function register (data) {
  return request({
    url: userApi.Register,
    method: 'post',
    data
  })
}
